const usersApprovalConstantsAR = {
  usersApprovalPageTitle: 'طلبات تسجيل المستخدمين',
  usersApprovalBreadcrumb: 'طلبات تسجيل المستخدمين',
  email: 'البريد الإلكتروني  ',
  name: 'الإسم',
  country: 'الدولة',
  companyName: 'اسم الجهة  ',
  purposeOfUse: 'الغرض من الاستخدام  ',
  registerDate: 'تاريخ التسجيل  ',
  status: 'الحالة  ',
  actions: 'الإجراءات  ',
  lastName: 'اسم العائلة  ',
  firstName: 'الاسم الأول  ',
  phoneNumber: 'رقم الهاتف  ',
  jobTitle: 'المسمى الوظيفي',
  companyWebsite: 'الموقع الإلكتروني',
  portalUsePropose: 'الغرض من استخدام المنصة  ',
  registerDateTime: 'تاريخ التسجيل  ',
  all: 'الجميع',
  pending: 'قيد الانتظار  ',
  approved: 'موافق عليه',
  rejected: 'مرفوض',
  approveAll: 'الموافقة على الكل  ',
  rejectAll: 'رفض الكل  ',
  userApprovalDeleteConfirmationTitle: 'حذف طلب الموافقة على المستخدم',
  userApprovalDeleteConfirmationContent: 'هل أنت متأكد من أنك تريد حذف',
  snackbarSuccessApprovedMsg: 'تم الموافقة على هذا المستخدم بنجاح',
  snackbarSuccessRejectedMsg: 'تم رفض المستخدم',
  contentDiscovery: 'اكتشاف المحتوى',
  marketplaceResearch: 'البحث في السوق',
  contentLicensing: 'ترخيص المحتوى',
  productResearch: 'البحث عن المنتجات',
  networkingAndCollaboration: 'التواصل والتعاون',
  other: 'أخرى',
  reject: 'رفض',
  approve: 'موافق',
};

export default usersApprovalConstantsAR;
